import CerticateCollectionX from "./multibrowser.js";
import { Message } from "element-ui";

/**
 * @description 判断浏览器
 */
export const isIE = () => {
  return "ActiveXObject" in window;
}
/**
 * @description 判断是否IE浏览器，根据浏览器不同初始化
 */
export const fun_IsIe = () => {
  if (isIE()) {
    //IE
    global.certs = document.getElementById("UCAPI");
    //alert('ie')
  } else {
    global.certs = new CerticateCollectionX();
  }
};

/**
 * @description 初始化
 *
 */
export const fun_ECCAInit = () => {
  // 根据属性设置过滤条件(1表示使用SKF接口，2表示CSP(CSP不能枚举SM2证书)，)
  global.certs.setCryptoInterface(1);
  global.certs.setCF_CertAlg("sm2");
  // 获取签名证书
  global.certs.setCF_KeyUsage(0x20);
  // 加载证书集返回值等于0表示成功
  let loadResult = global.certs.Load();
  let len = global.certs.getSize();
  if (loadResult != 0 || len < 1) {
    Message.error(
      "未取到证书信息，请确认是否已插入CA锁，若已插入CA锁，请在平台下载中心更新最新版驱动!",
      "提示",
      { type: "warning" }
    );
    return false;
  }
  // 加载证书
  global.cert = global.certs.GetAt(0);
  if (global.cert == null) {
    Message.error("获取客户端证书对象失败！", "提示", { type: "warning" });
    return false;
  }
  return true;
};

/**
 *  P7签名
 * @param data 签名内容
 * @return
 */
export const fun_SignMessageP7 = (data, pin) => {
  if (global.certs == null) {
    Message.error("获取客户端证书对象失败！", "提示", { type: "warning" });
    return;
  }
  //   var IsWithSource = 1;
  if (data == "") {
    Message.error("签名信息为空，请确认！", "提示", { type: "warning" });
    return;
  }
  // 返回结果
  var value = "";
  // 错误消息不返回
  global.cert.Quiet = "1";
  // 密码
  global.cert.setUserPIN(pin);
  // 进行签名
  value = global.cert.PKCS7String(data, 1);
  // 签名信息为空
  if (value == "" || value == null) {
    // 得到错误消息
    var errMsg = global.cert.getErrorString();
    // 提示错误消息
    Message.error(errMsg);
  }
  return value;
};

/**
 * P7验证
 * @param digitalSignature 签名信息
 * @param data 签名原文
 * @return
 */
export const fun_VerifyMessageByECCA = (digitalSignature, data) => {
  // 初始化
  if (fun_ECCAInit()) {
    if (data == "") {
      Message.error("签名信息为空，请确认！", "提示", { type: "warning" });
      return false;
    }
    // 获取验证信息
    var ret = global.certs.PKCS7VerifyA(digitalSignature, 1, data);
    if (ret == "0") {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

/**
 * CA检测锁品牌
 */
export const fun_CheckLockBrand = () => {
  // 控件初始化
  if (!fun_ECCAInit()) {
    return;
  }
  // 获取发证机构信息
  var organize = global.cert.getIssuer();
  // 颐信
  // CN=SM2RootCA, OU=ECCA, O=ECCA.COM.CN, S=Beijing, C=CN
  if (organize.indexOf("ECCA") > 1) {
    // 锁品牌--颐信
    return "201512281800350004";
  }
  // 信达汇格
  else if (organize.indexOf("SHECA") > 1) {
    // 锁品牌--信达汇格
    return "201512281800580005";
  }
  // 中金CA
  else if (organize.indexOf("CFCA") > 1) {
    // 锁品牌--中金CA
    return "201708031617450366";
  }
  // 湖北CA
  else if (organize.indexOf("HBCA") > 1) {
    // 锁品牌--湖北CA
    return "201811291813450004";
  } else {
    return "";
  }
};

/**
 * 获取对应锁品牌的品牌名称
 */
export const fun_CheckLockBrandName = (regLockBrand) => {
  // 颐信
  if ('201512281800350004' == regLockBrand) {
    // 锁品牌--颐信
    return '颐信科技';
  }
  // 信达汇格
  else if ('201512281800580005' == regLockBrand) {
    // 锁品牌--信达汇格
    return '信达汇格';
  }
  // 中金CA
  else if ('201708031617450366' == regLockBrand) {
    // 锁品牌--中金ca
    return '中金CA';
  }
  // 湖北CA
  else if ('201811291813450004' == regLockBrand) {
    // 证书品牌
    return '湖北CA';
  }
  else {
    return '';
  }
};
/**
 * 获取锁编号
 */
export const fun_GetLockNumber = () => {
  if (!fun_ECCAInit()) {
    return;
  }
  // 锁编号
  var lockNo = global.cert.getSerialNumber();
  return lockNo;
};

/**
 * 获取证书到期日
 * @returns 证书到期日
 */
export const fun_GetExpirationDate = () => {
  if (!fun_ECCAInit()) {
    return;
  }
  // 证书到期日
  var expirationDate = global.cert.getNotAfterSystemTime();
  return expirationDate;
};

/**
 * 获取组织机构代码
 */
export const fun_GetOrgId = () => {
  if (!fun_ECCAInit()) {
    return;
  }
  // 获取用户代码
  var orgCd = global.cert.GetExtensionString("1.2.156.10260.4.1.4", 0);
  // 用户代码为空
  if (orgCd == "" || orgCd == null) {
    // 获取用户代码
    orgCd = global.cert.GetExtensionString("1.2.86.11.7.3", 0);
  }
  // 用户代码为空
  if (orgCd == "" || orgCd == null) {
    // 获取用户代码
    orgCd = global.cert.GetExtensionString("1.2.156.10260.4.1.1", 0);
  }
  // 用户代码为空
  if (orgCd == "" || orgCd == null) {
    // 获取用户代码
    orgCd = global.cert.GetExtensionString("1.2.86.11.7.1", 0);
  }
  // 用户代码为空
  if (orgCd == "" || orgCd == null) {
    // 获取用户代码
    orgCd = global.cert.GetExtensionString("1.2.156.10260.4.1.2", 0);
  }
  orgCd = orgCd.replace(/[^0-9a-zA-Z-]/gi, "");
  return orgCd;
};
